<template>
  <div id="index">
    <Header />
        <router-view  class="backgroundPage"/>
    <Footer/>
  </div>
</template>

<script>
import Footer from '../../containers/website/Footer.vue'
import Header from '../../containers/website/Header.vue'
export default {
	components: { Header, Footer },
}
</script>
